import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row pt-2" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body p-3" }
const _hoisted_5 = { class: "text-secondary d-inline" }
const _hoisted_6 = /*#__PURE__*/_createVNode("ion-icon", { name: "arrow-back-outline" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Kembali ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Unduh Invoice ")
const _hoisted_9 = /*#__PURE__*/_createVNode("ion-icon", { name: "download-outline" }, null, -1)
const _hoisted_10 = { class: "row pt-2" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = {
  class: "card",
  id: "print"
}
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "card card-invoice border-0" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-12 text-end" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = { class: "row p-3" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createVNode("h5", { class: "text-secondary mt-3" }, "Tanggal Pembayaran", -1)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createVNode("h5", { class: "text-secondary mt-3" }, "Batas Pembayaran", -1)
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "col-md-6 text-end" }
const _hoisted_27 = { class: "fs3 fw-bold" }
const _hoisted_28 = { class: "fs4" }
const _hoisted_29 = { class: "fs4" }
const _hoisted_30 = { class: "fs4" }
const _hoisted_31 = { class: "row p-3" }
const _hoisted_32 = { class: "table table-borderless table-invoice" }
const _hoisted_33 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "bg-primary" }, [
    /*#__PURE__*/_createVNode("th", null, "Nama Tagihan"),
    /*#__PURE__*/_createVNode("th", null, "Periode"),
    /*#__PURE__*/_createVNode("th", { class: "text-end" }, "Total Bayar")
  ])
], -1)
const _hoisted_34 = { class: "badge bg-primary mr-1" }
const _hoisted_35 = { class: "badge bg-primary mr-1" }
const _hoisted_36 = { class: "text-primary text-end fw-bold" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createVNode("td", null, "Denda", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_40 = { class: "text-primary text-end fw-bold" }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/_createVNode("td", null, "Biaya Admin", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_44 = { class: "text-primary text-end fw-bold" }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = /*#__PURE__*/_createVNode("td", null, "Biaya Merchant", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_48 = { class: "text-primary text-end fw-bold" }
const _hoisted_49 = { key: 3 }
const _hoisted_50 = /*#__PURE__*/_createVNode("td", null, "Potongan Harga", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_52 = { class: "text-danger text-end fw-bold" }
const _hoisted_53 = { key: 4 }
const _hoisted_54 = /*#__PURE__*/_createVNode("td", null, "PPN", -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_56 = { class: "text-primary text-end fw-bold" }
const _hoisted_57 = /*#__PURE__*/_createVNode("td", {
  colspan: "2",
  class: "text-end pt-4 pb-4"
}, [
  /*#__PURE__*/_createVNode("span", { class: "text-secondary fs-3" }, "Jumlah Total")
], -1)
const _hoisted_58 = { class: "text-end pt-4 pb-4" }
const _hoisted_59 = { class: "text-primary fw-bold fs-3" }
const _hoisted_60 = /*#__PURE__*/_createVNode("td", {
  colspan: "2",
  class: "text-end pt-4 pb-4"
}, null, -1)
const _hoisted_61 = { class: "text-end pt-4 pb-4" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/_createVNode("ion-icon", { name: "card-outline" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Bayar")
const _hoisted_65 = {
  key: 1,
  class: "btn btn-success no-pointer"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("ion-icon", { name: "checkmark-outline" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" Lunas")
const _hoisted_68 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_69 = /*#__PURE__*/_createVNode("ion-icon", { name: "card-outline" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" Bayar Ulang")
const _hoisted_71 = /*#__PURE__*/_createVNode("ion-icon", { name: "refresh-circle-outline" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" Refresh")
const _hoisted_73 = { key: 1 }
const _hoisted_74 = {
  key: 0,
  class: "btn btn-success no-pointer"
}
const _hoisted_75 = /*#__PURE__*/_createVNode("ion-icon", { name: "checkmark-outline" }, null, -1)
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Lunas")
const _hoisted_77 = /*#__PURE__*/_createVNode("ion-icon", { name: "card-outline" }, null, -1)
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" Bayar")
const _hoisted_79 = { class: "table-secondary" }
const _hoisted_80 = {
  key: 0,
  colspan: "4",
  class: "p-4"
}
const _hoisted_81 = /*#__PURE__*/_createStaticVNode("<img src=\"https://aimsis.com/v2/img/ic_logo.svg\" alt=\"\"><button class=\"btn btn-link-gray float-end no-pointer\"> 0816-237-121 <ion-icon name=\"logo-whatsapp\"></ion-icon></button><button class=\"btn btn-link-gray float-end no-pointer\"> 021-533-2222 <ion-icon name=\"call-outline\"></ion-icon></button><button class=\"btn btn-link-gray float-end no-pointer\"> info@aimsis.com <ion-icon name=\"mail-outline\"></ion-icon></button>", 4)
const _hoisted_85 = {
  id: "xenditModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_86 = { class: "modal-dialog modal-lg" }
const _hoisted_87 = { class: "modal-content" }
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Pembayaran"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_89 = { class: "modal-body" }
const _hoisted_90 = { class: "modal-footer" }
const _hoisted_91 = /*#__PURE__*/_createVNode("ion-icon", { name: "close-outline" }, null, -1)
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" Tutup")
const _hoisted_93 = {
  id: "bcaModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_94 = { class: "modal-dialog modal-lg" }
const _hoisted_95 = { class: "modal-content" }
const _hoisted_96 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Pembayaran"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_97 = { class: "modal-body" }
const _hoisted_98 = { style: {"width":"100%"} }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Order Id", -1)
const _hoisted_101 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_102 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Nomor Invoice", -1)
const _hoisted_105 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_106 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_107 = {
  key: 0,
  style: {"padding":"10px"}
}
const _hoisted_108 = {
  key: 1,
  style: {"padding":"10px"}
}
const _hoisted_109 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_110 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_111 = { key: 2 }
const _hoisted_112 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Nomor Va 2", -1)
const _hoisted_113 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_114 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_115 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Total Biaya", -1)
const _hoisted_116 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_117 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_118 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Biaya Admin", -1)
const _hoisted_119 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_120 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_121 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Biaya Merchant", -1)
const _hoisted_122 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_123 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_124 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Total Diskon", -1)
const _hoisted_125 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_126 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_127 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "PPN", -1)
const _hoisted_128 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_129 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_130 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, [
  /*#__PURE__*/_createVNode("b", null, "Total Bayar")
], -1)
const _hoisted_131 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, [
  /*#__PURE__*/_createVNode("b", null, " : ")
], -1)
const _hoisted_132 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_133 = { key: 0 }
const _hoisted_134 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_135 = /*#__PURE__*/_createVNode("label", {
  for: "referenceFile",
  class: "form-label"
}, "Bukti Pembayaran", -1)
const _hoisted_136 = { class: "text-center mt-2" }
const _hoisted_137 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_138 = {
  key: 1,
  class: "alert alert-warning mt-2",
  role: "alert"
}
const _hoisted_139 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-outline-secondary",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "close-outline" }),
    /*#__PURE__*/_createTextVNode(" Tutup")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      title: "Invoice Pembayaran",
      link1: "Pembayaran",
      link2: _ctx.student.name
    }, null, 8, ["link2"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("h4", _hoisted_5, [
              _createVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
                class: "btn btn-light rounded-pill"
              }, [
                _hoisted_6
              ]),
              _hoisted_7
            ]),
            (_ctx.additional_data.is_hide_download_invoice == false || (_ctx.additional_data.is_hide_download_invoice == true && (_ctx.order.status == _ctx.constants.ORDER_SUCCESS || _ctx.order.status == _ctx.constants.ORDER_SUCCESS_MANUAL || !_ctx.order.us_order)))
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.customInvoice ? _ctx.getCustomInvoice() : _ctx.print())),
                  class: "btn btn-link-gray float-end"
                }, [
                  _hoisted_8,
                  _hoisted_9
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("h3", _hoisted_18, "INVOICE #" + _toDisplayString(_ctx.order.invoice_no), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_19, [
                  _createVNode("div", _hoisted_20, [
                    (_ctx.order.status == _ctx.constants.ORDER_SUCCESS || _ctx.order.status == _ctx.constants.ORDER_SUCCESS_MANUAL)
                      ? (_openBlock(), _createBlock("div", _hoisted_21, [
                          _hoisted_22,
                          _createVNode("h4", null, _toDisplayString(_ctx.beautifyDatetime(_ctx.order.payment_date)), 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_23, [
                          _hoisted_24,
                          _createVNode("h4", null, _toDisplayString(_ctx.beautifyDatetime(_ctx.order.expired_date)), 1)
                        ])),
                    (_ctx.order.us_order)
                      ? (_openBlock(), _createBlock("b", _hoisted_25, "Order ID: " + _toDisplayString(_ctx.order.us_order.us_merchant_order_id), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_26, [
                    _createVNode("h5", _hoisted_27, _toDisplayString(_ctx.student.name), 1),
                    _createVNode("h5", _hoisted_28, _toDisplayString(_ctx.student.student_profile.nis), 1),
                    _createVNode("h5", _hoisted_29, _toDisplayString(_ctx.student?.class?.name), 1),
                    _createVNode("h5", _hoisted_30, _toDisplayString(_ctx.school.name), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("table", _hoisted_32, [
                    _hoisted_33,
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.billUserInstallments, (detail) => {
                        return (_openBlock(), _createBlock("tr", {
                          key: detail.id
                        }, [
                          _createVNode("td", null, _toDisplayString(detail.bill_user.bill.name), 1),
                          _createVNode("td", null, [
                            _createVNode("span", _hoisted_34, _toDisplayString(_ctx.getMonth(detail.bill_user.id)), 1),
                            _createVNode("span", _hoisted_35, _toDisplayString(detail.bill_user.bill.school_year.name), 1)
                          ]),
                          _createVNode("td", _hoisted_36, " Rp" + _toDisplayString(_ctx.toLocaleString(detail.amount)), 1)
                        ]))
                      }), 128)),
                      (_ctx.order.total_charge > 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_37, [
                            _hoisted_38,
                            _hoisted_39,
                            _createVNode("td", _hoisted_40, " Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.order.total_charge)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.order.convenience_fee > 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_41, [
                            _hoisted_42,
                            _hoisted_43,
                            _createVNode("td", _hoisted_44, " Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.order.convenience_fee)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.order.merchant_fee > 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_45, [
                            _hoisted_46,
                            _hoisted_47,
                            _createVNode("td", _hoisted_48, " Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.order.merchant_fee)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.order.total_discount > 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_49, [
                            _hoisted_50,
                            _hoisted_51,
                            _createVNode("td", _hoisted_52, " Rp -" + _toDisplayString(_ctx.toLocaleString(_ctx.order.total_discount)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.order.ppn > 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_53, [
                            _hoisted_54,
                            _hoisted_55,
                            _createVNode("td", _hoisted_56, " Rp " + _toDisplayString(_ctx.toLocaleString(_ctx.order.ppn)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("tr", null, [
                        _hoisted_57,
                        _createVNode("td", _hoisted_58, [
                          _createVNode("span", _hoisted_59, "Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.order.total_payment)), 1)
                        ])
                      ]),
                      _createVNode("tr", null, [
                        _hoisted_60,
                        _createVNode("td", _hoisted_61, [
                          (_ctx.order.us_order)
                            ? (_openBlock(), _createBlock("span", _hoisted_62, [
                                (_ctx.order.status == _ctx.constants.ORDER_BEGIN || _ctx.order.status == _ctx.constants.ORDER_PENDING)
                                  ? (_openBlock(), _createBlock("a", {
                                      key: 0,
                                      class: "btn btn-primary",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handlePayment(_ctx.order.us_order_id)))
                                    }, [
                                      _hoisted_63,
                                      _hoisted_64
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.order.status == _ctx.constants.ORDER_SUCCESS || _ctx.order.status == _ctx.constants.ORDER_SUCCESS_MANUAL)
                                  ? (_openBlock(), _createBlock("a", _hoisted_65, [
                                      _hoisted_66,
                                      _hoisted_67
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.order.status == _ctx.constants.ORDER_CANCELED || _ctx.order.status == _ctx.constants.ORDER_EXPIRED)
                                  ? (_openBlock(), _createBlock("p", _hoisted_68, "Pembayaran Kedaluwarsa"))
                                  : _createCommentVNode("", true),
                                (_ctx.order.status == _ctx.constants.ORDER_CANCELED || _ctx.order.status == _ctx.constants.ORDER_EXPIRED)
                                  ? (_openBlock(), _createBlock("a", {
                                      key: 3,
                                      class: "btn btn-primary",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleExpiredPayment(_ctx.order.us_order_id)))
                                    }, [
                                      _hoisted_69,
                                      _hoisted_70
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.order.us_order.status == 600)
                                  ? (_openBlock(), _createBlock("button", {
                                      key: 4,
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadData())),
                                      class: "btn btn-icon btn-link-gray"
                                    }, [
                                      _hoisted_71,
                                      _hoisted_72
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_73, [
                                (_ctx.order.status == _ctx.constants.ORDER_SUCCESS || _ctx.order.status == _ctx.constants.ORDER_SUCCESS_MANUAL)
                                  ? (_openBlock(), _createBlock("a", _hoisted_74, [
                                      _hoisted_75,
                                      _hoisted_76
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.order.status == _ctx.constants.ORDER_BEGIN || _ctx.order.status == _ctx.constants.ORDER_PENDING)
                                  ? (_openBlock(), _createBlock("a", {
                                      key: 1,
                                      class: "btn btn-primary",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handlePayment2(_ctx.order)))
                                    }, [
                                      _hoisted_77,
                                      _hoisted_78
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                        ])
                      ])
                    ]),
                    _createVNode("tfoot", null, [
                      _createVNode("tr", _hoisted_79, [
                        (_ctx.additional_data.footer == '')
                          ? (_openBlock(), _createBlock("td", _hoisted_80, [
                              _hoisted_81
                            ]))
                          : (_openBlock(), _createBlock("td", {
                              key: 1,
                              colspan: "4",
                              class: "p-4",
                              innerHTML: _ctx.additional_data.footer
                            }, null, 8, ["innerHTML"]))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_85, [
      _createVNode("div", _hoisted_86, [
        _createVNode("div", _hoisted_87, [
          _hoisted_88,
          _createVNode("div", _hoisted_89, [
            (_ctx.xenditInvoice != '')
              ? (_openBlock(), _createBlock("iframe", {
                  key: 0,
                  src: _ctx.xenditInvoice,
                  frameborder: "0",
                  width: "100%",
                  height: "700"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_90, [
            _createVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              "data-bs-dismiss": "modal",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadData()))
            }, [
              _hoisted_91,
              _hoisted_92
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_93, [
      _createVNode("div", _hoisted_94, [
        _createVNode("div", _hoisted_95, [
          _hoisted_96,
          _createVNode("div", _hoisted_97, [
            _createVNode("table", _hoisted_98, [
              (_ctx.bca.orderId !== '')
                ? (_openBlock(), _createBlock("tr", _hoisted_99, [
                    _hoisted_100,
                    _hoisted_101,
                    _createVNode("td", _hoisted_102, _toDisplayString(_ctx.bca.orderId), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bca.invoice_number !== '')
                ? (_openBlock(), _createBlock("tr", _hoisted_103, [
                    _hoisted_104,
                    _hoisted_105,
                    _createVNode("td", _hoisted_106, _toDisplayString(_ctx.bca.invoice_number), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("tr", null, [
                (_ctx.bca.va_number_nobill === '')
                  ? (_openBlock(), _createBlock("td", _hoisted_107, "Nomor Va"))
                  : (_openBlock(), _createBlock("td", _hoisted_108, "Nomor Va 1")),
                _hoisted_109,
                _createVNode("td", _hoisted_110, [
                  _createTextVNode(_toDisplayString(_ctx.bca.bank_name) + " " + _toDisplayString(_ctx.bca.va_number) + " ", 1),
                  _createVNode("ion-icon", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.copyValue(_ctx.bca.va_number))),
                    name: "copy-outline"
                  })
                ])
              ]),
              (_ctx.bca.va_number_nobill !== '')
                ? (_openBlock(), _createBlock("tr", _hoisted_111, [
                    _hoisted_112,
                    _hoisted_113,
                    _createVNode("td", _hoisted_114, [
                      _createTextVNode(_toDisplayString(_ctx.bca.bank_name) + " " + _toDisplayString(_ctx.bca.va_number_nobill) + " ", 1),
                      _createVNode("ion-icon", {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.copyValue(_ctx.bca.va_number))),
                        name: "copy-outline"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("tr", null, [
                _hoisted_115,
                _hoisted_116,
                _createVNode("td", _hoisted_117, _toDisplayString(_ctx.formatPrice(_ctx.bca.amount)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_118,
                _hoisted_119,
                _createVNode("td", _hoisted_120, _toDisplayString(_ctx.formatPrice(_ctx.bca.convenience_fee)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_121,
                _hoisted_122,
                _createVNode("td", _hoisted_123, _toDisplayString(_ctx.formatPrice(_ctx.bca.merchant_fee)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_124,
                _hoisted_125,
                _createVNode("td", _hoisted_126, "-" + _toDisplayString(_ctx.formatPrice(_ctx.bca.total_discount)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_127,
                _hoisted_128,
                _createVNode("td", _hoisted_129, _toDisplayString(_ctx.formatPrice(_ctx.bca.ppn)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_130,
                _hoisted_131,
                _createVNode("td", _hoisted_132, [
                  _createVNode("b", null, _toDisplayString(_ctx.formatPrice(_ctx.bca.total_payment)), 1)
                ])
              ])
            ]),
            (_ctx.canUploadReference)
              ? (_openBlock(), _createBlock("hr", _hoisted_133))
              : _createCommentVNode("", true),
            (_ctx.canUploadReference)
              ? (_openBlock(), _createBlock("div", _hoisted_134, [
                  _hoisted_135,
                  _createVNode("input", {
                    type: "file",
                    class: "form-control",
                    id: "referenceFile",
                    onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                    accept: "image/*,application/pdf"
                  }, null, 32),
                  _createVNode("div", _hoisted_136, [
                    (_ctx.referenceFile)
                      ? (_openBlock(), _createBlock("div", _hoisted_137, [
                          _createVNode("img", {
                            src: _ctx.referenceFile,
                            class: "img-fluid",
                            style: {"max-height":"400px","max-width":"100%"}
                          }, null, 8, ["src"])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_138, " Bukti pembayaran tidak tersedia. "))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_139
        ])
      ])
    ])
  ], 64))
}